"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cell = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var isClickable = ui_blocks_1.INTERACTIVE.isClickable,
    isSelected = ui_blocks_1.INTERACTIVE.isSelected;
var patternStyles = {
  idle: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    ", "\n    background-color: ", ";\n    color: ", ";\n  "], ["\n    ", "\n    background-color: ", ";\n    color: ", ";\n  "])), isClickable, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
  }, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.DARK', theme);
  }),
  selected: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n    background-color: ", ";\n    color: ", ";\n  "], ["\n    background-color: ", ";\n    color: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ACTION', theme);
  }, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
  }),
  today: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), isSelected),
  other: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n    ", "\n    background-color: ", ";\n    color: ", ";\n  "], ["\n    ", "\n    background-color: ", ";\n    color: ", ";\n  "])), isClickable, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
  }, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.MEDIUM', theme);
  }),
  range: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n    ", "\n    border-radius: 0;\n    background-color: ", ";\n    color: ", ";\n  "], ["\n    ", "\n    border-radius: 0;\n    background-color: ", ";\n    color: ", ";\n  "])), isClickable, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.BLUE[100]', theme);
  }, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.DARK', theme);
  }),
  startDate: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    background-color: ", ";\n    color: ", ";\n  "], ["\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    background-color: ", ";\n    color: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ACTION', theme);
  }, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
  }),
  endDate: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    background-color: ", ";\n    color: ", ";\n  "], ["\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    background-color: ", ";\n    color: ", ";\n  "])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ACTION', theme);
  }, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
  })
};

var makePatternStyles = function makePatternStyles(_a) {
  var isSelected = _a.isSelected,
      isToday = _a.isToday,
      isOtherMonth = _a.isOtherMonth,
      isInRange = _a.isInRange,
      isSelectedStartDate = _a.isSelectedStartDate,
      isSelectedEndDate = _a.isSelectedEndDate,
      isStartDateAndEndDateSame = _a.isStartDateAndEndDateSame;

  switch (true) {
    case isOtherMonth:
      {
        return patternStyles.other;
      }

    case isSelected:
    case isStartDateAndEndDateSame:
      {
        return patternStyles.selected;
      }

    case isSelectedStartDate:
      {
        return patternStyles.startDate;
      }

    case isSelectedEndDate:
      {
        return patternStyles.endDate;
      }

    case isInRange:
      {
        return patternStyles.range;
      }

    case isToday:
      {
        return patternStyles.today;
      }

    default:
      {
        return patternStyles.idle;
      }
  }
};

exports.Cell = styled_components_1.default.td(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  height: 2rem;\n  border-radius: ", ";\n  line-height: 1.75rem;\n  border-collapse: separate;\n\n  ", "\n"], ["\n  width: 100%;\n  height: 2rem;\n  border-radius: ", ";\n  line-height: 1.75rem;\n  border-collapse: separate;\n\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS.DEFAULT', theme);
}, function (props) {
  return makePatternStyles(props);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;